import dynamic from 'next/dynamic'

export const DynamicCouponTermsModal = dynamic(
  () => import('.').then((mod) => mod.CouponTermsModal),
  { ssr: false },
)
